import config from '../config'

async function grafanaLogout() {
    // Skip Grafana logout if running on localhost (development environment)
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        console.log('Skipping Grafana logout in development environment');
        return;
    }

    try {
        const response = await fetch(`${config.grafanaUrl}/logout`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        return response.json()
    } catch (error) {
        // Silently fail if Grafana logout fails - don't block user logout
        console.warn('Grafana logout failed:', error);
    }
}

export { grafanaLogout }
